<div class="ngx-editor-message" *ngIf="ngxMessage" (dblclick)="clearMessage()">
  {{ ngxMessage }}
</div>
